import { useDesignContext } from '@systemeio/digital-store-shared'
import { PrimaryButton, toast } from '@systemeio/ui'
import { useStoresApi } from 'modules/stores/hooks/use-stores-api'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useStore } from '../../hooks/use-store'
import { useStoreQuery } from '../../hooks/use-store-query'
import { SaveIcon } from '@systemeio/ui'

export function StoreThemeSaveButton({ className, title }: { className?: string; title?: string }) {
  const { t } = useLocoTranslation()
  const [isFetching, setIsFetching] = useState(false)

  const { updateStoreDesign } = useStoresApi()

  const { storeId, redirectToMainPage } = useStoreQuery()

  const { mutate, data: store } = useStore(storeId)

  const { state } = useDesignContext()

  const onSave = async () => {
    if (!store) return
    setIsFetching(true)
    try {
      await updateStoreDesign(store.id, { design: state })
      await mutate(data => data && { ...data, design: state }, false)
      toast.success(t('global.changes_saved'))
      await redirectToMainPage()
    } catch {
    } finally {
      setIsFetching(false)
    }
  }

  return (
    <PrimaryButton onClick={onSave} isFetching={isFetching} disabled={!store} className={className}>
      <SaveIcon />
      <b>{title ?? t('global.save')}</b>
    </PrimaryButton>
  )
}
